import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { isCreateEvent, isJoinEvent, isMessageEvent } from '../utils/events';
import { MatrixMessage } from './MatrixMessage';
export var MatrixRoomStatus;

(function (MatrixRoomStatus) {
  MatrixRoomStatus[MatrixRoomStatus["UNKNOWN"] = 0] = "UNKNOWN";
  MatrixRoomStatus[MatrixRoomStatus["JOINED"] = 1] = "JOINED";
  MatrixRoomStatus[MatrixRoomStatus["INVITED"] = 2] = "INVITED";
  MatrixRoomStatus[MatrixRoomStatus["LEFT"] = 3] = "LEFT";
})(MatrixRoomStatus || (MatrixRoomStatus = {}));

export var MatrixRoom = /*#__PURE__*/function () {
  function MatrixRoom(id) {
    var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MatrixRoomStatus.UNKNOWN;
    var members = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var messages = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    _classCallCheck(this, MatrixRoom);

    this.id = id;
    this.status = status;
    this.members = members;
    this.messages = messages;
  }
  /**
   * Reconstruct rooms from a sync response
   *
   * @param roomSync
   */


  _createClass(MatrixRoom, null, [{
    key: "fromSync",
    value: function fromSync(roomSync) {
      function create(rooms, creator) {
        return Object.entries(rooms).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              id = _ref2[0],
              room = _ref2[1];

          return creator(id, room);
        });
      }

      return [].concat(_toConsumableArray(create(roomSync.join, MatrixRoom.fromJoined)), _toConsumableArray(create(roomSync.invite, MatrixRoom.fromInvited)), _toConsumableArray(create(roomSync.leave, MatrixRoom.fromLeft)));
    }
    /**
     * Reconstruct a room from an ID or object
     *
     * @param roomOrId
     * @param status
     */

  }, {
    key: "from",
    value: function from(roomOrId, status) {
      return typeof roomOrId === 'string' ? new MatrixRoom(roomOrId, status || MatrixRoomStatus.UNKNOWN) : status !== undefined ? new MatrixRoom(roomOrId.id, status, roomOrId.members, roomOrId.messages) : roomOrId;
    }
    /**
     * Merge new and old state and remove duplicates
     *
     * @param newState
     * @param previousState
     */

  }, {
    key: "merge",
    value: function merge(newState, previousState) {
      if (!previousState || previousState.id !== newState.id) {
        return MatrixRoom.from(newState);
      }

      return new MatrixRoom(newState.id, newState.status, [].concat(_toConsumableArray(previousState.members), _toConsumableArray(newState.members)).filter(function (member, index, array) {
        return array.indexOf(member) === index;
      }), [].concat(_toConsumableArray(previousState.messages), _toConsumableArray(newState.messages)));
    }
    /**
     * Create a room from a join
     *
     * @param id
     * @param joined
     */

  }, {
    key: "fromJoined",
    value: function fromJoined(id, joined) {
      var events = [].concat(_toConsumableArray(joined.state.events), _toConsumableArray(joined.timeline.events));
      var members = MatrixRoom.getMembersFromEvents(events);
      var messages = MatrixRoom.getMessagesFromEvents(events);
      return new MatrixRoom(id, MatrixRoomStatus.JOINED, members, messages);
    }
    /**
     * Create a room from an invite
     *
     * @param id
     * @param invited
     */

  }, {
    key: "fromInvited",
    value: function fromInvited(id, invited) {
      var members = MatrixRoom.getMembersFromEvents(invited.invite_state.events);
      return new MatrixRoom(id, MatrixRoomStatus.INVITED, members);
    }
    /**
     * Create a room from a leave
     *
     * @param id
     * @param left
     */

  }, {
    key: "fromLeft",
    value: function fromLeft(id, left) {
      var events = [].concat(_toConsumableArray(left.state.events), _toConsumableArray(left.timeline.events));
      var members = MatrixRoom.getMembersFromEvents(events);
      var messages = MatrixRoom.getMessagesFromEvents(events);
      return new MatrixRoom(id, MatrixRoomStatus.LEFT, members, messages);
    }
    /**
     * Extract members from an event
     *
     * @param events
     */

  }, {
    key: "getMembersFromEvents",
    value: function getMembersFromEvents(events) {
      return MatrixRoom.getUniqueEvents(events.filter(function (event) {
        return isCreateEvent(event) || isJoinEvent(event);
      })).map(function (event) {
        return event.sender;
      }).filter(function (member, index, array) {
        return array.indexOf(member) === index;
      });
    }
    /**
     * Extract messages from an event
     *
     * @param events
     */

  }, {
    key: "getMessagesFromEvents",
    value: function getMessagesFromEvents(events) {
      return MatrixRoom.getUniqueEvents(events.filter(isMessageEvent)).map(function (event) {
        return MatrixMessage.from(event);
      }).filter(Boolean);
    }
    /**
     * Get unique events and remove duplicates
     *
     * @param events
     */

  }, {
    key: "getUniqueEvents",
    value: function getUniqueEvents(events) {
      var eventIds = {};
      var uniqueEvents = [];
      events.forEach(function (event, index) {
        var eventId = event.event_id;

        if (eventId === undefined || !(eventId in eventIds)) {
          if (eventId !== undefined) {
            eventIds[eventId] = index;
          }

          uniqueEvents.push(event);
        }
      });
      return uniqueEvents;
    }
  }]);

  return MatrixRoom;
}();